import { useCallback, useEffect, useMemo, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { managementApiRef } from '@internal/plugin-management';
import { dateInputValue } from '../homeUtils';
import type { Announcement } from '@internal/plugin-management-common';

export function useHomeAnnouncements(): Announcement[] {
  const managementApi = useApi(managementApiRef);
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const today = dateInputValue(new Date());

  const fetchAnnouncements = useCallback(async () => {
    try {
      setAnnouncements(await managementApi.listAnnouncements());
    } catch (error) {
      console.error('Error fetching home announcements:', error);
      setAnnouncements([]);
    }
  }, [managementApi]);

  useEffect(() => {
    void fetchAnnouncements();
    const interval = window.setInterval(fetchAnnouncements, 45000);
    window.addEventListener('focus', fetchAnnouncements);
    return () => {
      window.clearInterval(interval);
      window.removeEventListener('focus', fetchAnnouncements);
    };
  }, [fetchAnnouncements]);

  return useMemo(
    () =>
      announcements.filter(
        item => !item.expires_at || item.expires_at >= today,
      ),
    [announcements, today],
  );
}
